<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Customers" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex justify-content-between align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-3 user_role">
              <span>To Date</span>
              <datepicker :upperLimit="upperLimitDate" v-model="toDate" class="form-control"/>
            </div>
            <div class="col-md-3 user_plan">
              <span>From Date</span>
              <datepicker :upperLimit="upperLimitDate" v-model="fromDate" class="form-control"/>
            </div>
            <div class="col-md-3 user_status">
              <span>Search Keyword</span>
              <input class="form-control" type="text" v-model="search" placeholder="Search here..."/>
            </div>
            <div class="col-md-3 user_status">
              <button type="button" class="btn btn-primary mt-1" @click="onSubmitFilters">Search</button>
              <button type="button" class="ml-2 btn btn-dark mt-1" @click="clear">Clear</button>
            </div>
          </div>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <SearchSelect
                      v-model="selectedStore"
                      @selectedFullObj="selectedFullObj"
                      url="v1/get-stores"
                      :extract-options="(res) => res.data?.stores || []"
                      placeholder="Search Store..."
                  />

                </div>
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedTerminal">
                      <option :value="null">Select Terminal</option>
                      <option :key="index" :value="option" v-for="(option, index) in terminalData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="terminalLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 user_plan">
              <div class="form-group row">
                <div class="col-sm-12">
                  <div class="input-group input-group input-group-merge">
                    <select class="form-control" v-model="selectedChannel">
                      <option :value="null">Select Store</option>
                      <option :key="index" :value="option" v-for="(option, index) in channelData">
                        {{ option.name }}
                      </option>
                    </select>
                    <div v-if="channelLoader" class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <div class="spinner-border text-primary spinner-border-sm"></div>
                                </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="card">
          <div class="">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                </div>
              </div>
            </div>
          </div>
          <CommonTable
              url="v1/get-merchant-customers"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :mutedData="[]"
              :filteredData="filteredData"
              customClass="table-hover-animation"
          />
        </div>
      </div>
    </div>
    <CustomerCardsModal :show="showCardsModal" :data="cardsData"
                        @hide="showCardsModal = false"

    />
  </div>
  <!-- END: Content-->
</template>

<script>
import CustomerCardsModal from "@/pages/dashboard/customer/CustomerCardsModal";
import Datepicker from 'vue3-datepicker'
import { ref } from 'vue'
import SearchSelect from "@/components/common/SearchSelect.vue";
export default {
  components:{SearchSelect, CustomerCardsModal,Datepicker},
  mounted() {
  },
  data() {
    return {
      search:'',
      toDate: ref(new Date()),
      fromDate: ref(new Date()),
      cardsData: [],
      showCardsModal: false,
      breadcrumb: [
        {name: 'App'},
        {name: 'Merchant Customer'},
      ],
      tableHeaderValues: [
        {
          title: 'Name',
          valueKey: 'name',

        },
        {
          title: 'Customer Email',
          valueKey: 'email',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = ` <a href="javascript:void()" class="badge badge-glow badge-light-success">${value}</a>`

            return html


          }
        },
        {
          title: 'Phone',
          valueKey: 'phone',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary">${value}</span>`


            return html


          }
        },
        {
          title: 'Country',
          valueKey: 'country',
          html: true,
          alter: function (value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: 'City',
          valueKey: 'city',
          html: true,
          alter: function (value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: 'Total Transactions',
          valueKey: 'transactions_count',
          html: true,
          alter: function (value) {
            var html = ''
            html = `<span class="text-info">${value}</span>`


            return html


          }
        },
        {
          title: 'Created',
          valueKey: 'created_at',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        {
          title: "Details",
          class: "btn-primary mt-1",
          cta: (row, index) => {
            this.cardsData = row.cards
            this.showCardsModal = true
          }
        },
      ],
      filteredData:{},
      selectedMerchant: null,
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
    }
  },
  methods: {
    formatDate(val){
      let date = new Date(val)
      let day = ("0" + date.getDate()).slice(-2)
      let month = ("0" + (date.getMonth() + 1)).slice(-2)
      let year= date.getFullYear()

      let formatted_date = year+'-'+month+'-'+day
      return formatted_date
    },
    onSubmitFilters() {

      let filterData = {}

      if(this.selectedStore){
        filterData.storeId = this.selectedStore
      }
      if(this.selectedTerminal){
        filterData.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        filterData.channelId = this.selectedChannel.id
      }

      if(this.search != ''){
        filterData.search = this.search
      }
      if(this.toDate){
        filterData.toDate = this.formatDate(this.toDate)
      }
      if(this.fromDate){
        filterData.fromDate = this.formatDate(this.fromDate)
      }

      this.filteredData = filterData






    },
    clear(){
      this.toDate = null
      this.fromDate = null
      this.search = ''
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.filteredData = {}




    },
    selectedFullObj(obj){
      if(obj){
        this.terminalData = obj.terminals
      }else{
        this.terminalData = []
      }
    },
  },
  watch:{
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
      }
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      this.channelData = []
      if(val){
        this.channelData = val.channels
      }
    },
  }
}
</script>

